import type { ShortCircuitScenarioElementCalculation } from '../../..';
import type { CalculationResult } from '../../../derived-state/CalculationResult';
import { ShortCircuitProperty } from '../../../derived-state/gridElementsDetailsByCalculationType/shortCircuit/ShortCircuitProperty';
import type { ElectricCurrentType } from '../../../domain/ElectricCurrent';
import type { EvaluatedResult } from '../../EvaluatedResult';
import type { ForFaultsEvaluation } from '../ForFaultsEvaluation';
import { evaluateFaultCurrent } from './evaluateGridElement';

export class FaultEvaluation {
  private constructor(
    private readonly gridElement: ShortCircuitScenarioElementCalculation,
    private readonly evaluationEngine: ForFaultsEvaluation
  ) {}

  static create(
    gridElement: ShortCircuitScenarioElementCalculation,
    evaluationEngine: ForFaultsEvaluation
  ): FaultEvaluation {
    return new FaultEvaluation(gridElement, evaluationEngine);
  }

  onePhaseToGroundMin(): CalculationResult<
    EvaluatedResult<ElectricCurrentType>
  > {
    return evaluateFaultCurrent(
      ShortCircuitProperty.from1PhaseToGroundMin(
        this.gridElement.id,
        this.gridElement.result
      ),
      this.evaluationEngine.evaluate1PhaseToGroundMin
    );
  }

  onePhaseToGroundMax(): CalculationResult<
    EvaluatedResult<ElectricCurrentType>
  > {
    return evaluateFaultCurrent(
      ShortCircuitProperty.from1PhaseToGroundMax(
        this.gridElement.id,
        this.gridElement.result
      ),
      this.evaluationEngine.evaluate1PhaseToGroundMax
    );
  }

  twoPhasesMin(): CalculationResult<EvaluatedResult<ElectricCurrentType>> {
    return evaluateFaultCurrent(
      ShortCircuitProperty.from2PhasesMin(
        this.gridElement.id,
        this.gridElement.result
      ),
      this.evaluationEngine.evaluate2PhasesMin
    );
  }

  threePhasesMax(): CalculationResult<EvaluatedResult<ElectricCurrentType>> {
    return evaluateFaultCurrent(
      ShortCircuitProperty.from3PhasesMax(
        this.gridElement.id,
        this.gridElement.result
      ),
      this.evaluationEngine.evaluate3PhasesMax
    );
  }
}
